module.exports = require('./helpers/bundle-url').getBundleURL('iDchs') + "logo-dark.eefe0b7f.svg";